import * as yup from 'yup';

yup.addMethod(yup.string, 'alphaApostrophe', function (args) {
  return this.test({
    name: 'alphaApostrophe',
    message: args?.message || 'The field must not contain special characters',
    test: (value) => {
      return /^[^0-9_%$#@!;:\"|}(){+=*<>?~,`|\\\/\[\]\^]+$/g.test(value);
    },
  });
});

const isValidField = (name, value, schema) => {
  try {
    schema.validateSyncAt(name, { [name]: value });
    return true;
  } catch (err) {
    return false;
  }
};

const getInputClass = (name, inputValue, errors, schema) => {
  if (Object.keys(errors).length > 0 && errors[name]) {
    return 'invalid';
  } else if (isValidField(name, inputValue, schema) && !errors[name]) {
    return 'valid';
  } else {
    return 'untouched';
  }
};

export { isValidField, getInputClass };
export default yup;
